import { render, staticRenderFns } from "./appQrcode.vue?vue&type=template&id=5c2503d5&scoped=true&"
import script from "./appQrcode.vue?vue&type=script&lang=js&"
export * from "./appQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2503d5",
  null
  
)

export default component.exports